/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingMetricFilters {
    getFixupPrototypeFunction() { return BillingMetricFilters.fixupPrototype; }

    static newInstance(model: Partial<BillingMetricFilters>): BillingMetricFilters {
        let obj = Object.assign(new BillingMetricFilters(), model);
        BillingMetricFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingMetricFilters>): BillingMetricFilters {
        if (!model) return null;
        return BillingMetricFilters.newInstance(<BillingMetricFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingMetricFilters) {
        if (!obj) return;

        models.BillingMetricFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingMetricFilters): boolean {
        Object.setPrototypeOf(obj, BillingMetricFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.descendant_service_account_query) {
            models.DescendantServiceAccountQuery.fixupPrototype(this.descendant_service_account_query);
        }
    }

    /**
     * Service Account IDs to filter
     */
    service_account_ids: Array<string>;

    /**
     * Descendant service account query filter
     */
    descendant_service_account_query: models.DescendantServiceAccountQuery;

}
